export interface DefaultNavigationProps
{
  key?: string;
  title: string;
  timePeriodInDays: number;
}

export const NavigationProps = {
  title: "Week Ending",
  timePeriodInDays: 7
} as DefaultNavigationProps;


export const WeightNavigationProps = {
  title: "4 Weeks Ending",
  timePeriodInDays: 28
} as DefaultNavigationProps;